<mat-card class="cardWithShadow" style="margin: 0; height: 100%;overflow: hidden;border-radius: 0;">
  <mat-card-header class="w-100 d-block p-0" style="background-color: #1e293b;border-bottom: 3px solid #5d87ff;">
    <mat-card-title>
      <div class="w-100 d-flex" style="background: #0f172a;">
        <span style="display: flex; align-items: center; margin-left: 15px; color: #1bbaee; font-size: 14px;">{{ "Avertissement expiration licence CaurisLinkUp" | translate }}</span>
        <button class="m-l-auto" mat-icon-button (click)="matDialogRef.close();">
          <i-tabler name="x" class="icon-18" style="color: #1bb3e6;"></i-tabler>
        </button>
      </div>
    </mat-card-title>
    <mat-card-subtitle style="background: #dee8ff;color: black;" class="p-t-16 p-b-16">
      <div class="d-flex">
        <div class="d-flex flex">
          <div style="border-right: 2px solid #1855d5; margin-right: 15px;">
            <button mat-icon-button>
              <i-tabler name="building-arch" class="icon-24 d-flex" style="color: #1cc8ff; align-items: center;"></i-tabler>
            </button>
          </div>
          <div class="d-grid">
            <span class="f-w-700"> Avertissement de l'expiration prochaine de votre licence </span>
            <span style="padding-top: 8px; font-size: 13px; color: #9b9b9f; font-weight: 600;">{{ "Expiration" | translate }}</span>
          </div>
        </div>
        <div class="m-l-auto">
        </div>
      </div>
    </mat-card-subtitle>
  </mat-card-header>
  <mat-card-content style="flex: 1;padding: 0;overflow: auto;">
    <p style="font-weight: 700; text-align: center; line-height: 30px; color: #dd3f3f; text-decoration: underline; background-color: #f5e0e6; margin: 0; padding: 20px;">
      Avertissement expiration de votre licence CaurisLinkUp.
    </p>
    <p style="font-weight: 700; text-align: center; line-height: 30px;">
      Votre licence CaurisLinkUp arrivera à expiration dans <span style="color: #dd3f3f;">{{ daysLeft }} jours</span>, soit le <span style="color: #dd3f3f;">{{ authSessionDto.LICENCE_DATE_EXPIRATION | date : 'dd/MM/yyyy' }}</span>.
    </p>
    <div style="height: 130px; display: flex;">
      <i-tabler style="color: #f78888; align-items: center; width: 128px; text-align: center; margin: auto;" name="lock" class="d-flex"></i-tabler>
    </div>
    <p style="font-weight: 700; text-align: center; line-height: 30px;">
      Afin de garantir la continuité de vos services et éviter toute interruption, nous vous recommandons de renouveler votre licence avant cette date. 
      Vous pouvez procéder au renouvellement en contactant votre partenaire Sage.
    </p>
  </mat-card-content>
  <mat-card-actions class="d-block m-0 p-0" style="background-color: #ffffff; border-top: 3px solid #5d87ff;">
    <div class="d-flex w-100" style="padding-top: 6px;">
      <button mat-flat-button color="ccdark"(click)="matDialogRef.close();" style="font-weight: 700; border: 1px solid; margin-left: 10px; margin-right: 10px; flex: 1;">
        {{ "J'AI COMPRIS" | translate }} 
      </button>
    </div>
  </mat-card-actions>
</mat-card>